/**
 * JavaScript responsible for showing post type specific facets in faceted search when post type
 * selection is changed.
 */
(() => {
    let main = document.querySelector('.js-faceted-search-main-container');
    let radio_buttons = document.querySelectorAll(
        '.js-faceted-search-post-type-radio-button'
    );
    let headers = document.querySelectorAll(
        '.js-faceted-search-filters-heading'
    );
    let facets = document.querySelectorAll(
        '.js-faceted-search-facet-container'
    );

    if (!main || !radio_buttons.length || !headers.length || !facets.length) {
        return;
    }

    /**
     *
     * @param {*} post_type A post type key
     */
    function activate(post_type) {
        // console.log('Activating post type ' + post_type);

        // Toggle a modifier class to indicate if this post type has facets
        main.classList.toggle('-no-facets', !hasFacets(post_type));

        // Show post type header
        headers.forEach(function (header) {
            header.classList.toggle(
                '-visible',
                header.getAttribute('data-pt') === post_type
            );
        });

        // Show post type facets
        facets.forEach(function (facet) {
            const facet_post_type = facet.getAttribute('data-pt');
            const is_current_post_type = facet_post_type === post_type;

            enableInputs(facet, is_current_post_type);
            facet.classList.toggle('-visible', is_current_post_type);
            main.classList.toggle(
                '-post-type-' + facet_post_type,
                is_current_post_type
            );
        });
    }

    /**
     * Enables or disables all facet inputs inside the supplied DOM element.
     *
     * @param {*} el     A DOM element
     * @param {*} enable If `true` the inputs are enabled, if `false` the inputs are disabled
     */
    function enableInputs(el, enable) {
        el.querySelectorAll('.js-facet-input')?.forEach((input) => {
            input.disabled = !enable;
        });
    }

    /**
     *
     * @param {*} post_type A post type key
     * @returns
     */
    function getFacetContainer(post_type) {
        for (let i = 0; i < facets.length; i++) {
            const facet_post_type = facets[i].getAttribute('data-pt');
            if (facet_post_type === post_type) {
                return facets[i];
            }
        }
    }

    /**
     * Checks if the specified post type has facets. Returns a representative boolean value.
     *
     * @param {*} post_type A post type key
     */
    function hasFacets(post_type) {
        return (
            getFacetContainer(post_type).getAttribute('data-has-facets') ===
            'true'
        );
    }

    function radioButtonClicked() {
        if (this.checked) {
            activate(this.getAttribute('value'));
        }
    }

    radio_buttons.forEach(function (radio_button) {
        radio_button.addEventListener('click', radioButtonClicked);

        if (radio_button.checked) {
            activate(radio_button.getAttribute('value'));
        }
    });
})();
